// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import router from './router';
import Mint from 'mint-ui';
import 'mint-ui/lib/style.css';
import './assets/scss/index.scss';
import store from './store';
import vueTap from 'v-tap';
// import vueTap from './components/tap.js';
import App from './App';
import Base from './components/base.js';
//按需引入elementui
import { Image,Upload,Dialog,Select,Option,Button,DatePicker} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 引入 Element UI 的样式文件

//引入组件
import vueEsign from 'vue-esign';

Vue.use(vueEsign)

// 全局注册 Image 和 Upload 组件
Vue.component(Image.name, Image);
Vue.component(Upload.name, Upload);
Vue.component(Dialog.name, Dialog);
Vue.component(Select.name, Select);
Vue.component(Option.name, Option);
Vue.component(Button.name, Button);
Vue.component(DatePicker.name, DatePicker);
//  ------- mint -----
Vue.use(Mint);
Base.resize(document, window);
Vue.config.productionTip = false;
Vue.use(vueTap);

// router 钩子函数 ----
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    if (store.state.userInfo.user) {
      next();
    } else {
      next({
        path: '/login',
        query: {redirect: to.fullPath}
      });
    }
  } else {
    next();
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App}
});



// WEBPACK FOOTER //
// ./src/main.js